<template>
  <div id="profile-edit">
    <vx-card title="Your Details" class="mb-6">
      <form>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 mb-4">
            <vx-field
              type="input"
              class="w-full"
              label="Name"
              v-model="profile.name"
              v-validate="{ required: true }"
            />
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-4">
            <vx-field
              type="input"
              class="w-full"
              label="Email"
              v-model="profile.email"
              v-validate="{ email: true, required: true }"
            />
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-4">
            <vx-field
              type="select"
              autocomplete
              class="w-full"
              label="Timezone"
              :options="{
                value: 'id',
                text: 'title',
                items: timezones || []
              }"
              v-model="profile.metaData.timezone"
              v-validate="{ required: true }"
            />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="ml-auto" @click.prevent="saveChanges" icon-pack="feather" icon="icon-check" icon-before>Save Changes</vs-button>
          </div>
        </div>
      </form>
    </vx-card>

  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {},
  data () {
    return {
      profile: JSON.parse(JSON.stringify(this.$store.state.auth.me.user)),
      isMounted: false,
      isList: true
    };
  },
  computed: {
    ...mapState('visitManagement', ['timezones'])
  },
  methods: {
    saveChanges () {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$store.dispatch('auth/me', {
            user: this.profile
          });
        }
      })
    }
  },
  async created () {
    await this.$store.dispatch('visitManagement/timezones');
  },
  mounted () {
    this.isMounted = true;
  }
};
</script>